import React, { useEffect } from "react";
import { Form } from "antd";
import SignInSettings from "./AuthenticationCards/SignInSettings";
import AuthenticationTable from "./AuthenticationCards/AuthenticationTable";

const Authentication = ({ userId, form }) => {
  return (
    <Form form={form} layout="vertical">
      <SignInSettings form={form} />
      {/* <AuthenticationTable /> */}
    </Form>
  );
};

export default Authentication;
